/* src/app/components/loading/loading.component.scss */
.loadingShadow {
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1500;
}
.loadingContainer {
  top: 50%;
  position: absolute;
  left: 50%;
  margin-top: -100px;
  margin-bottom: -100px;
  z-index: 1501;
}
.loadingText {
  text-align: center;
  margin-top: -50px;
}
/*# sourceMappingURL=loading.component.css.map */
